/* unplugin-vue-components disabled */import { render } from "./pulse-num.vue?vue&type=template&id=5e388d88&scoped=true"
import script from "./pulse-num.vue?vue&type=script&lang=js"
export * from "./pulse-num.vue?vue&type=script&lang=js"

import "./pulse-num.vue?vue&type=style&index=0&id=5e388d88&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e388d88"],['__file',"src/pages/pulse/pulse-num.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e388d88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e388d88', __exports__)) {
    api.reload('5e388d88', __exports__)
  }
  
  module.hot.accept("./pulse-num.vue?vue&type=template&id=5e388d88&scoped=true", () => {
    api.rerender('5e388d88', render)
  })

}


export default __exports__